import { useContext } from 'react'

import Grid from '@mui/material/Grid'

import { ROLE_LEVEL } from 'constants/roles'
import { useAuth } from 'context/auth'
import Customer from 'layouts/feedback/internal/components/Customer'
import Details from 'layouts/feedback/internal/components/Details'
import MemberOutcome from 'layouts/feedback/internal/components/MemberOutcome'
import { FormContext } from 'layouts/feedback/internal/constants'

function CommendationForm() {
	const { user } = useAuth()
	const formContext = useContext(FormContext)
	const { isNew } = formContext
	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Details />
			</Grid>
			<Grid item xs={12}>
				<Customer />
			</Grid>
			{!isNew && ROLE_LEVEL[4].includes(user.data.role) && (
				<>
					<Grid item xs={12}>
						<MemberOutcome />
					</Grid>
				</>
			)}
		</Grid>
	)
}

export default CommendationForm
